
// 例子
const option = {
  series: [
    {
      type: 'gauge',
      radius: "95%",
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 100,
      center: ['50%', '70%'],
      itemStyle: {
        color: '#58D9F9',
      },
      // 进度条
      progress: {
        show: true,
        roundCap: true,
        width: 5
      },
      // 指针
      pointer: {
        icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
        length: '75%',
        width: 4,
        offsetCenter: [0, '5%']
      },
      // X轴
      axisLine: {
        roundCap: true,
        lineStyle: {
          width: 5
        }
      },
      // 刻度线(细分)
      axisTick: {
        distance: 5,
        splitNumber: 4,
        lineStyle: {
          width: 2,
          color: '#999'
        }
      },
      // 刻度线(粗)
      splitNumber: 5,
      splitLine: {
        length: 8,
        distance:5,
        lineStyle: {
          width: 2,
          color: '#999'
        }
      },
      // 刻度线Label
      axisLabel: {
        distance: 10,
        color: '#999',
        fontSize: 10
      },
      // 标题
      title: {
        show: false
      },
      // 详细说明标题
      detail: {
        height: 20,
        formatter: function () {
          // return ""
          return '{value|' + '内存占用率' + '}';
        },
        rich: {
          value: {
            fontSize: 15,
            fontWeight: 'bolder',
            color: '#777'
          },
        },
      },
      data: [
        {
          value: 30
        }
      ]
    }
  ]
};

export function getGauge(value, color, title){
  if(!value){
    value = 0;
  }
  if(!color){
    color = "#58D9F9"
  }
  let gaugeOpt = {
    series: {
      ...option.series[0],
      itemStyle: {
        color: color,
      },
      data: [{
        value: value,
      }],
      // 详细说明标题
      detail: {
        ...option.series[0].detail,
        formatter: function () {
          return '{value|' + title + '}';
        },
      },
    },
  }
  return gaugeOpt
}